import React from 'react';
import {Box} from '@mui/material';
import type {
  BulkUpdate,
  BulkUpdateItemStatus,
} from 'services/bulkUpdates/types';
import {useLocalization} from 'localization';
import {IconButton, Text} from 'components';

type Props = Pick<BulkUpdate, 'type'> & {
  itemStatus: BulkUpdateItemStatus;
  itemIds: string[];
  showOpenInSearch: boolean;
  onSearch: (itemIds: string[]) => void;
};

export const BulkUpdateTableHeader: React.FC<Props> = ({
  type,
  itemStatus,
  itemIds,
  showOpenInSearch,
  onSearch,
}) => {
  const {t} = useLocalization();
  return (
    <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
      <Box>
        <Text variant={'body1'}>
          {t(`page.bulkUpdate.details.${type}.${itemStatus}.title`, {
            count: itemIds.length,
          })}
        </Text>
      </Box>
      <Box>
        {showOpenInSearch ? (
          <IconButton
            icon={'Search'}
            size={'small'}
            onClick={() => onSearch(itemIds)}
            postText={<Text variant={'body1'}>{'Åpne i søk'}</Text>}
          />
        ) : null}
      </Box>
    </Box>
  );
};
